import * as actionTypes from "../actions/actionTypes";

const initialState: {} = {
  loading: false,
  error: false,
  errorMessage: "",
  submitted: false,
};
const submitProcedureShopper = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_PROCEDURE_SHOPPER_STARTED:
      return {
        ...state,
        loading: true,
        error: false,
        submitted: false,
      };
    case actionTypes.SUBMIT_PROCEDURE_SHOPPER_FAILED: {
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload,
        submitted: false,
      };
    }
    case actionTypes.SUBMIT_PROCEDURE_SHOPPER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        submitted: true,
      };
    }
    default:
      return state;
  }
};
export default submitProcedureShopper;
